import { useAtomValue } from "jotai";
import type { FunctionComponent } from "react";
import { graphql, readInlineData } from "react-relay";

import { currentArticleAtom } from "~/lib/current-item";
import type { headerContentBookmarkArticle$key } from "~/queries/__generated__/headerContentBookmarkArticle.graphql";

import { StyledContentBookmark } from "./styles";

export const HeaderContentBookmark: FunctionComponent = () => {
  const currentArticle = useAtomValue(currentArticleAtom);
  if (!currentArticle) return null;

  const data = readInlineData<headerContentBookmarkArticle$key>(
    graphql`
      fragment headerContentBookmarkArticle on Article @inline {
        entityId
        urlAlias
      }
    `,
    currentArticle,
  );

  return <StyledContentBookmark entityId={data.entityId} urlAlias={data.urlAlias} />;
};

HeaderContentBookmark.displayName = "HeaderContentBookmark";
